<template>
	<transition name="popup-show">
		<div
			ref="popup"
			v-show="value"
			class="popup-container"
			:class="{ 'tooltip-mode': tooltipMode }"
			@click="closePopup()"
		>
			<div
				class="popup"
				role="dialog"
				@click.stop
				data-scroll-lock-scrollable
				:style="{ width: popupWidth }"
			>
				<div
					class="popup__header d-md-none"
					v-if="!tooltipMode"
				>
					<button
						class="btn-back"
						@click="closePopup()"
					>
						{{ $t('back') }}
					</button>
					<div class="title">{{ titleMobile }}</div>
				</div>

				<div class="popup__inner">
					<slot></slot>
				</div>

				<div
					class="popup__footer d-md-none"
					v-if="$slots.footerMobile && !tooltipMode"
				>
					<slot name="footerMobile"></slot>
				</div>

				<button
					class="popup__close-btn btn-close"
					:class="{ dark: !tooltipMode }"
					aria-label="Close modal"
					@click="closePopup()"
				></button>
			</div>

			<slot name="outside"></slot>
		</div>
	</transition>
</template>

<script>
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

export default {
	props: {
		value: {
			type: Boolean,
			required: true,
		},
		width: {
			default: 900,
		},
		tooltipMode: {
			type: Boolean,
			default: false,
		},
		titleMobile: String,
	},

	watch: {
		value(show) {
			this.$nextTick(() => {
				let isVisible =
					this.$refs.popup.offsetWidth > 0 ||
					this.$refs.popup.offsetWidth > 0
				show && isVisible ? disablePageScroll() : enablePageScroll()
			})
		},
	},

	computed: {
		popupWidth() {
			if (this.width == 'auto') return 'auto'
			else return this.width + 'px'
		},
	},

	methods: {
		closePopup() {
			// Обновляем v-model:
			this.$emit('input', false)
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.popup-container {
	z-index: 200;
	position: fixed;
	background: rgba(13, 13, 13, 0.4);
	backdrop-filter: blur(28px);
	top: 0;
	left: 0;
	width: 100vw;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 3vh 3vw;
	.popup {
		position: relative;
		background: #ffffff;
		box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		max-width: 100%;
		max-height: 100%;
		transition: 0.2s ease;
		overflow-y: auto;
		color: #333333;
		background: #ffffff;
		&__inner {
			padding: 52px;
			overflow-x: hidden;
		}
		&__close-btn {
			top: 24px;
			right: 24px;
		}
	}
	&.tooltip-mode {
		.popup {
			background: linear-gradient(
				90deg,
				rgba(102, 0, 204, 0.85) 5.34%,
				rgba(1, 51, 255, 0.85) 91.03%
			);
			color: #fff;
		}
	}
}

@media (max-width: $md) {
	.popup-container:not(.tooltip-mode) {
		background: none;
		backdrop-filter: none;
		padding: 0;
		.popup {
			border-radius: 0;
			background: linear-gradient(
					90deg,
					rgba(102, 0, 204, 0.33) 5.34%,
					rgba(1, 51, 255, 0.33) 91.03%
				),
				#030f15;
			color: #ffffff;
			height: 100%;
			display: flex;
			flex-direction: column;
			transition: 0.4s;
			&__header {
				padding: 12px 9px;
				.btn-back {
					position: absolute;
				}
				.title {
					text-align: center;
					font-weight: 600;
					font-size: 17px;
					padding: 1px 82px 0;
					letter-spacing: -0.4px;
				}
			}
			&__footer {
				padding: 12px 16px;
			}
			&__inner {
				flex-grow: 1;
				padding: 20px 16px;
			}
			&__close-btn {
				display: none;
			}
		}
	}
}
@media (max-width: $sm) {
	.popup-container.tooltip-mode {
		.popup {
			&__inner {
				padding: 48px 36px;
			}
		}
	}
}

.popup-show-enter,
.popup-show-leave-active {
	opacity: 0;
	.popup {
		transform: scale(0.6);
	}
}
.popup-show-enter-active,
.popup-show-leave-active {
	transition: 0.25s;
}
@media (max-width: $md) {
	.popup-show-enter,
	.popup-show-leave-active {
		.popup {
			transform: scale(0.75) translateY(125%);
		}
	}
}
</style>
